var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"end"},[_c('div',{staticClass:"question"},[_vm._v(_vm._s(_vm.$t('promotion_new.end_date')))]),_c('datetime',{attrs:{"type":"datetime","use12-hour":true},model:{value:(_vm.promotion.endAt),callback:function ($$v) {_vm.$set(_vm.promotion, "endAt", $$v)},expression:"promotion.endAt"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }